export const names = [
  {
    'label': 'Tráfico y Ventas',
    'value': 'SALES_AND_TRAFFIC',
    'async': true,
    'snapshot': false,
  },
  {
    'label': 'Devoluciones',
    'value': 'RETURNS',
    'async': true,
    'snapshot': false,
  },
  {
    'label': 'Devoluciones FBA',
    'value': 'RETURNS_FBA',
    'async': true,
    'snapshot': false,
  },
  {
    'label': 'Inventario FBA Snapshot',
    'value': 'INVENTORY_FBA_SNAPSHOT',
    'async': true,
    'snapshot': true,
  },
  {
    'label': 'Search Catalog Performance (WEEKLY)',
    'value': 'CATALOG_PERFORMANCE',
    'async': true,
    'snapshot': false,
  },
  {
    'label': 'Restock Inventory Report',
    'value': 'RESTOCK_INVENTORY',
    'async': true,
    'snapshot': false,
  },
  {
    "label": "All Listings Report",
    "value": "ALL_LISTINGS",
    "async": true,
    "snapshot": false
  }
  /*{
    'label': 'Search Query Performance (WEEKLY)',
    'value': 'QUERY_PERFORMANCE',
    'async': true,
    'snapshot': false,
  }*/
]
